<template>
  <div class="row">
    <div class="col-xl-3 col-md-6 xl-50" v-for="card in cards" :key="card.label">
      <div class="card o-hidden widget-cards">
        <div :class="'bg-' + card.variant + ' card-body'" :style="textStyle(card)">
          <div class="media static-top-widget row">
            <div class="icons-widgets col-4">
              <div class="align-self-center text-center">
                <feather :type="card.icon" :style="'color:' + card.color"></feather>
              </div>
            </div>
            <div class="media-body col-8">
              <span class="m-0">{{ card.label }}</span>
              <h5 class="mb-0 f-w-600">{{ card.value }}</h5>
              <small :class="card.dark ? 'text-muted' : 'text-white-50'">{{ card.caption }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatMoney, formatNumber } from "../../../utils/store-stats";

export default {
  name: "store-kpi-cards",
  props: {
    stats: { type: Object, required: true }
  },
  computed: {
    cards() {
      const k = this.stats.kpis;
      const symbol = this.stats.currencySymbol;
      return [
        {
          label: "Revenue",
          icon: "dollar-sign",
          color: "#4680ff",
          variant: "primary",
          dark: false,
          value: formatMoney(k.revenue, symbol),
          caption: formatMoney(k.revenueMonth, symbol) + " this month"
        },
        {
          label: "Orders",
          icon: "shopping-cart",
          color: "#51bb25",
          variant: "success",
          dark: false,
          value: formatNumber(k.orderCount),
          caption: formatNumber(k.ordersMonth) + " this month"
        },
        {
          label: "Average basket",
          icon: "shopping-bag",
          color: "#ffb64d",
          variant: "warning",
          dark: true,
          value: formatMoney(k.avgBasket, symbol),
          caption: "across " + formatNumber(k.orderCount) + " orders"
        },
        {
          label: "Low stock",
          icon: "alert-triangle",
          color: "#f73164",
          variant: "danger",
          dark: false,
          value: formatNumber(k.lowStock),
          caption: formatNumber(k.outOfStock) + " out of stock"
        }
      ];
    }
  },
  methods: {
    textStyle(card) {
      return card.dark ? "color:#212529" : "color:#fff";
    }
  }
};
</script>

<style></style>
